<template>
    <div>
        <div class="large-8 columns content__column">
            <h2>Glemt passord</h2>
            <p>
                Skriv inn e-postadressen som du har registrert for din bruker,<br />
                så sender vi deg ditt brukernavn og passord.
            </p>

            <div v-if="failed" class="form__errors">Det oppstod en feil. Vennligst kontroller e-postadressen du har oppgitt.</div>

            <div v-if="success" class="form__errors">
                Dersom dette er en registrert e-postadresse hos oss,<br />så har vi sendt deg en e-post med en link der du kan endre passordet ditt.
            </div>

            <div class="row form">
                <div class="form__field small-12 medium-7 columns">
                    <label class="form__label">
                        E-postadresse <span class="form__required">*</span>
                        <input type="text" name="email" maxlength="255" required autofocus v-model="email" v-validate="'required'" data-vv-as="Brukernavn" />
                        <span v-show="errors.has('email')" class="form__field__error">{{ errors.first('email') }}</span>
                    </label>
                </div>
                <div class="form__submit small-12 large-7 columns"><button @click.prevent="sendPassword" class="button form__submit__button">Send</button></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            success: false,
            failed: false,
        };
    },
    created() {
        var _this = this;
        this.$auth.ready(function() {});
    },
    methods: {
        sendPassword() {
            var _this = this;
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    // reset
                    _this.success = false;
                    _this.failed = false;

                    // post
                    _this
                        .$http({ method: 'post', url: '/caller/password/email', data: { email: _this.email } })
                        .then(function(response) {
                            // success
                            if (response && response.data) {
                                _this.success = true;
                                // console.log(response.data);
                            }
                        })
                        // failed
                        .catch(function(error) {
                            // console.log(error.response);
                            _this.failed = true;
                            if (error.response && error.response.data) {
                                // var data = error.response.data;
                                // if(data.errors) {
                                //     console.log(data.errors);
                                // }
                            }
                        });
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/RecoverPassword.vue